import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { RouterModule } from '@angular/router';
import { NavbarComponent } from '../../../layout/navbar/navbar.component';
import { SfgeService } from '../../../core/services/sfge.service';
import { PatientService } from '../../../core/services/patient.service';
import { AccessiService } from '../../../core/services/accessi.service';
import { SfgeHelper } from '../../../core/helpers/sfge.helper';
import { PatientsmartHeaderComponent } from '../../../shared/components/patientsmart-header/patientsmart-header.component';
import Chart from 'chart.js/auto';

@Component({
  selector: 'app-sfge-trend',
  standalone: true,
  imports: [
    CommonModule,
    NavbarComponent,
    RouterModule,
    PatientsmartHeaderComponent
  ],
  templateUrl: './sfge-trend.component.html',
  styleUrls: ['./sfge-trend.component.scss']
})
export class SfgeTrendComponent
  implements OnInit {

  idPaziente!: number;

  patient: any = null;

  idAccesso!: number;

  sfgeList: any[] = [];

  expandedSfgeId: number | null = null;

  selectedSfge: any = null;

  public sfgeHelper = SfgeHelper;

  chart: any;

  accessiCount = 0;

  source = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private sfgeService: SfgeService,
    private patientService: PatientService,
    private accessiService: AccessiService
  ) { }

  ngOnInit(): void {

    this.idPaziente =
      Number(
        this.route.snapshot.paramMap.get(
          'idPaziente'
        )
      );

    const accessoParam =

      this.route.snapshot.paramMap.get(
        'idAccesso'
      );

    this.idAccesso =

      accessoParam
        ? Number(accessoParam)
        : 0;

    this.source =
      this.route.snapshot.queryParamMap.get(
        'source'
      ) || '';

    this.loadPatient();

    this.loadTrend();

    this.loadAccessiCount();
  }

  loadAccessiCount(): void {

    this.accessiService
      .getByPatient(
        this.idPaziente
      )
      .subscribe({

        next: response => {

          this.accessiCount =
            response.length;
        }
      });
  }

  loadPatient(): void {

    this.patientService
      .getById(this.idPaziente)
      .subscribe({

        next: response => {

          this.patient = response;
        }
      });
  }

  loadTrend(): void {

    this.sfgeService
      .getByPatient(this.idPaziente)
      .subscribe({

        next: response => {

          this.sfgeList = response;

          setTimeout(() => {

            this.renderChart();

          }, 100);
        }
      });
  }

  goBack(): void {

    if (this.idAccesso > 0) {

      this.router.navigate([
        '/accessi',
        this.idAccesso
      ]);

      return;
    }

    if (this.source === 'patient') {

      this.router.navigate([
        '/patients',
        this.idPaziente
      ]);

      return;
    }

    this.router.navigate([
      '/home'
    ]);
  }

  getDelta(): number {

    if (this.sfgeList.length < 2)
      return 0;

    return (
      this.sfgeList[0].punteggioTotale -
      this.sfgeList[
        this.sfgeList.length - 1
      ].punteggioTotale
    );
  }

  toggleRiepilogo(idSfge: number) {

    if (this.expandedSfgeId === idSfge) {

      this.expandedSfgeId = null;
      return;
    }

    this.sfgeService
      .getById(idSfge)
      .subscribe(sfge => {

        this.selectedSfge = sfge;

        this.expandedSfgeId = idSfge;
      });
  }

  renderChart(): void {

    if (this.chart) {

      this.chart.destroy();
    }

    const ordered =

      [...this.sfgeList]

        .sort(

          (a, b) =>

            new Date(a.dataAccesso).getTime()

            -

            new Date(b.dataAccesso).getTime()

        );

    const labels =

      ordered.map(

        x =>

          new Date(x.dataAccesso)

            .toLocaleDateString('it-IT')

      );

    const scores =

      ordered.map(

        x => x.punteggioTotale

      );

    this.chart = new Chart(

      'sfgeChart',

      {

        type: 'line',

        data: {

          labels: labels,

          datasets: [

            {

              label: 'Punteggio SFGE',

              data: scores,

              borderWidth: 3,

              tension: 0.35,

              fill: false
            }
          ]
        },

        options: {

          responsive: true,

          plugins: {

            legend: {

              display: false
            }
          },

          scales: {

            y: {

              beginAtZero: true,

              ticks: {

                stepSize: 2
              }
            }
          }
        }
      }
    );
  }

  getTrendDescription(): string {

    if (this.sfgeList.length < 2) {

      return 'Non disponibile';
    }

    const ordered =

      [...this.sfgeList]

        .sort(
          (a, b) =>
            new Date(a.dataAccesso).getTime()
            -
            new Date(b.dataAccesso).getTime()
        );

    const first =
      ordered[0].punteggioTotale;

    const last =
      ordered[ordered.length - 1]
        .punteggioTotale;

    if (last > first) {

      return 'Peggioramento';
    }

    if (last < first) {

      return 'Miglioramento';
    }

    return 'Stabile';
  }

  get firstScore(): number | null {

    if (!this.sfgeList?.length) {

      return null;
    }

    const ordered =

      [...this.sfgeList]

        .sort(
          (a, b) =>
            new Date(a.dataAccesso).getTime()
            -
            new Date(b.dataAccesso).getTime()
        );

    return ordered[0].punteggioTotale;
  }

  get lastScore(): number | null {

    if (!this.sfgeList?.length) {

      return null;
    }

    const ordered =

      [...this.sfgeList]

        .sort(
          (a, b) =>
            new Date(a.dataAccesso).getTime()
            -
            new Date(b.dataAccesso).getTime()
        );

    return ordered[
      ordered.length - 1
    ].punteggioTotale;
  }

}